'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _streamController = require('hls.js/src/controller/stream-controller');

var _streamController2 = _interopRequireDefault(_streamController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StreamController = function (_BaseStreamController) {
    _inherits(StreamController, _BaseStreamController);

    function StreamController() {
        _classCallCheck(this, StreamController);

        return _possibleConstructorReturn(this, (StreamController.__proto__ || Object.getPrototypeOf(StreamController)).apply(this, arguments));
    }

    _createClass(StreamController, [{
        key: 'onFragLoaded',

        /**
         * Override the original method and drop all non-video fragments.
         * @param data
         */
        value: function onFragLoaded(data) {
            var _this2 = this;

            var frag = data.frag;
            var title = frag.title || '';
            var type = title.split(';')[0];

            if (type === 'video') {
                _get(StreamController.prototype.__proto__ || Object.getPrototypeOf(StreamController.prototype), 'onFragLoaded', this).call(this, data);
            } else {
                setTimeout(function () {
                    _this2.state = 'IDLE';
                    _this2.tick();
                }, frag.duration * 1000);
            }
        }
    }]);

    return StreamController;
}(_streamController2.default);

exports.default = StreamController;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/player/overrides/hls.js/controller/stream-controller.js
// module id = 217
// module chunks = 0